import { useEffect } from "react"
import { useRoleStore } from "@/app/store/slices/role-store"
import InspectorForm from "./components/inspector-form"
import FormPage from "./components/form"
import { useNavigate } from "react-router-dom"
import ArrowRightIcon from "@/pages/icons/arrow-right"

const SubmitRequestPage = () => {
  const role = useRoleStore(state => state.role)
  const navigate = useNavigate()

  useEffect(() => {
    if (!role) {
      navigate("/auth/select-role")
    }
  }, [role, navigate])

  if (!role) return null

  return (
    <div className="dark:bg-zinc-500 bg-white p-8 flex flex-col gap-6 rounded-xl w-full max-w-[752px]">
      <div className="text-center flex flex-col gap-3 relative">
        <button onClick={() => navigate("/auth/role-select")}>
          <ArrowRightIcon className="rotate-180 absolute top-0 left-0" />
        </button>
        <h3 className="text-[#101A23] text-[28px] font-medium">{role.name}</h3>
        <p className="text-[#738195] text-[20px] ">Выберите электронный ключ для входа в систему</p>
      </div>
      <hr />
      {role.value === "regional_inspector" ? <InspectorForm /> : <FormPage />}
    </div>
  )
}

export default SubmitRequestPage
